<template lang="">
  <div style="position: relative;">
    <div id="top" :class="{top2_back:$route.path==='/news/detail'||$route.path==='/search'|| isTarget }">
      <div class="top_container">
        <div>
          <router-link to="/">
            <img data-aos="zoom-out-right" data-aos-duration="500" class="top_logo" :src="t_logo" alt="">
          </router-link>
          <div class="t_left">
            <ul>
              <li @mouseenter="setActive(-1)" @mouseleave="remove(-1)"
                :class="{ active: activeIndex === -1||$route.path==='/' }">
                <router-link to="/" :class="{t_black:$route.path==='/news/detail'||$route.path==='/search'|| isTarget}">
                  首页
                  <div></div>
                </router-link>
              </li>
              <li v-for="(item, index) in navList" :key="index" @mouseenter="setActive(item.id)"
                @mouseleave="remove(item.id)"
                :class="{ active: activeIndex === item.id||$route.path.includes(item.path)}">
                <router-link :to="item.path"
                  :class="{t_black:$route.path==='/news/detail'||$route.path==='/search'|| isTarget}">
                  {{item.title}}
                  <div></div>
                </router-link>
              </li>
            </ul>
            <div class="t_search" v-click-outside="closeSearch">
              <input ref="searchInput" @keyup.enter="goSearch()" v-model="title" placeholder="请搜索"
                :class="{'t_search_content':true,'s_expand':expand===true,'t_gray':$route.path==='/news/detail'||$route.path==='/search'|| isTarget}"
                type="text">
              <svg @click.stop="toggleSearch"
                style=" cursor: pointer; position: absolute;left: 7.5%;top: 50%; transform: translateY(-50%);"
                t="1738812311249" class="icon magnifier" viewBox="0 0 1024 1024" version="1.1"
                xmlns="http://www.w3.org/2000/svg" p-id="4287">
                <path
                  d="M1011.975 960.664 785.583 759.823c28.026-35.029 50.8-73.962 67.876-116.211 22.961-56.813 34.604-117.132 34.604-179.274 0-62.144-11.644-122.459-34.604-179.273-22.211-54.957-54.027-104.332-94.561-146.751-40.643-42.532-88.014-75.944-140.797-99.307C563.323 14.759 505.137 2.464 445.16 2.464c-59.979 0-118.166 12.294-172.944 36.542-52.783 23.363-100.154 56.775-140.797 99.307-40.536 42.421-72.35 91.794-94.563 146.751C13.894 341.877 2.251 402.194 2.251 464.338c0 62.143 11.643 122.461 34.605 179.274 22.211 54.954 54.027 104.329 94.563 146.749 40.643 42.532 88.014 75.944 140.797 99.307 54.779 24.246 112.965 36.541 172.944 36.541 59.977 0 118.164-12.295 172.941-36.541 43.84-19.405 83.932-45.765 119.552-78.504l227.722 202.025c6.686 5.929 15.002 8.846 23.287 8.846 9.691 0 19.336-3.991 26.275-11.811C1027.809 995.72 1026.48 973.532 1011.975 960.664zM445.161 855.992c-205.503 0-372.693-175.696-372.693-391.654 0-215.961 167.189-391.658 372.693-391.658 205.501 0 372.688 175.697 372.688 391.658C817.849 680.298 650.661 855.992 445.161 855.992z"
                  fill="#bfbfbf" p-id="4288"></path>
              </svg>
              </input>
            </div>
          </div>
        </div>
      </div>
      <div v-show="shouldShowTop2" :style="{opacity:shouldShowTop2?1:0}" class="top2">
        <div>
        </div>
        <ul @mouseleave="activeSec=null" :style="{opacity:shouldShowTop2?1:0}">
          <li @mouseenter="setActive2(item.id)" @mouseleave="remove2(item.id)" class="sec_title"
            v-show="activeSec===item.category_id" v-for="(item,index) in navList2" :key="index">
            <router-link :to="item.path">
              <div>{{item.title}}</div>
              <img :src="item.pic" alt="">
            </router-link>
          </li>
        </ul>
      </div>

    </div>
    <!-- <div v-if="$route.path==='/'" class="banner_title" :style="{opacity: !shouldShowTop2 ?1:0}">
      {{TitleList[0]?.title}}
    </div>
    <div v-else-if="$route.path.includes('/introduce')" class="banner_title" :style="{opacity: !shouldShowTop2 ?1:0}">
      <div class="biaoti1">{{TitleList[1]?.title}}</div>
    </div>
    <div v-else-if="$route.path.includes('/about')" class="banner_title" :style="{opacity: !shouldShowTop2 ?1:0}">
      <div class="biaoti1">{{TitleList[2]?.title}}</div>
    </div>
    <div v-else-if="$route.path.includes('/cooperate')" class="banner_title" :style="{opacity: !shouldShowTop2 ?1:0}">
      <div class="biaoti1">{{TitleList[3]?.title}}</div>
    </div>
    <div v-else-if="$route.path.includes('/show')" class="banner_title" :style="{opacity: !shouldShowTop2 ?1:0}">
      <div class="biaoti1">{{TitleList[4]?.title}}</div>
    </div>
    <div v-else-if="$route.path.includes('/news')" class="banner_title" :style="{opacity: !shouldShowTop2 ?1:0}">
      <div class="biaoti1">{{TitleList[5]?.title}}</div>
    </div> -->
  </div>
</template>
<script>
  export default {
    props: ['navList', 'navList2', 'siteList'],
    data() {
      return {
        title: '',
        expand: false,
        expand1: false,
        activeIndex: null,// 当前激活的菜单项索引
        activeSec: null,//显示二级菜单
        secIndex: null,
        isTarget: false,
        scrollRatio: 0.9,
        TitleList:[]
      }
    },
    mounted() {
      window.addEventListener('scroll', this.handleScroll);
      this.getBannerTitle()
    },
    beforeDestroy() {
      window.removeEventListener('scroll', this.handleScroll);
    },
    computed: {
      shouldShowTop2() {
        return this.navList2.some(item => item.category_id === this.activeSec);
      },
      t_logo() {
        return this.$route.path === '/news/detail' || this.$route.path === '/search' || this.isTarget
          ? this.siteList.top_logo2
          : this.siteList.top_logo;
      },
    },

    methods: {
      handleScroll() {
        const scrollY = window.scrollY || window.pageYOffset;
        const viewportHeight = window.innerHeight;
        // 计算动态阈值（视口高度的80%）
        const dynamicThreshold = viewportHeight * this.scrollRatio;
        this.isTarget = scrollY > dynamicThreshold;
      },
      toggleSearch() {
        this.expand = !this.expand; // 直接切换状态
        if (this.expand) {
          this.$nextTick(() => {
            this.$refs.searchInput?.focus(); // 确保 DOM 更新后聚焦
          });
        }
      },
      closeSearch() {
        if (this.expand) {
          this.expand = false;
        }
      },
      // 鼠标进入时设置激活索引
      setActive(id) {
        this.activeIndex = id;
        this.activeSec = id;
      },
      // 鼠标离开时清除激活索引
      remove(id) {
        if (this.activeIndex === id) {
          this.activeIndex = null;
        }
      },
      setActive2(id) {
        this.secIndex = id;
      },
      // 鼠标离开时清除激活索引
      remove2(id) {
        if (this.secIndex === id) {
          this.secIndex = null;
        }
      },
      //搜索功能
      goSearch() {
        this.$router.push({ path: '/search', query: { title: this.title } })
        this.title = ''
      },
      async getBannerTitle() {
        let res = await this.$request.post('BannerTitle/getAll')
        if (res.data.code === 0) {
          this.TitleList = res.data.data
        }
      },
    },
  }
</script>
<style lang="scss" scoped>
  .active {
    a {
      color: #E60012 !important;

      >div {
        position: absolute;
        left: 50%;
        bottom: 20%;
        transform: translateX(-50%);
        width: 30px !important;
        height: 2px;
        background-color: #E60012;
      }
    }
  }

  .sec_title {
    color: #FFFFFF;
  }

  .sec_title {
    &:hover {
      a {
        div {
          color: #E60012;
        }
      }
    }
  }

  .banner_title {
    position: absolute;
    font-weight: normal;
    font-size: 110px;
    left: 50%;
    top: 120px;
    letter-spacing: 50px;
    width: 100%;
    text-align: center;
    z-index: 10;
    transform: translateX(-50%);
    transition: all 0.3s ease;
    /* 添加由上往下的渐变 */
    background: linear-gradient(to bottom, #D0F8FF, rgba(255, 255, 255, 0.8));
    -webkit-background-clip: text;
    /* 使渐变应用于文字 */
    -webkit-text-fill-color: transparent;
    /* 使文字颜色透明，显示背景渐变 */
  }

  .banner_title2 {
    position: absolute;
    font-weight: normal;
    font-size: 80px;
    left: 50%;
    top: 150px;
    width: 100%;
    text-align: center;
    z-index: 10;
    transform: translateX(-50%);
    transition: all 0.3s ease;
    letter-spacing: 5px;

    .biaoti1 {
      display: inline-block;
      width: auto;
      height: auto;
      /* 添加由上往下的渐变 */
      background: linear-gradient(to bottom, #FFFFFF, rgba(255, 255, 255, 0.3));
      -webkit-background-clip: text;
      /* 使渐变应用于文字 */
      -webkit-text-fill-color: transparent;
      /* 使文字颜色透明，显示背景渐变 */
    }

    .biaoti2 {
      color: #FFFFFF;
      font-size: 30px;
      margin-top: 20px;
      letter-spacing: 5px;
    }
  }

  .magnifier {
    width: 24px;
    height: 24px;
  }

  .top2_back {
    background: white !important;
  }

  .t_black {
    color: #474646 !important;
  }

  .t_gray {
    background-color: #F3F5F7 !important;
  }
</style>